import store from '@/VueWorking/store.js'

export default function useAuth() {
    const login = async (credentials) => {
        try {
            let validationErrors = Array();
            await axios.get('/sanctum/csrf-cookie')
                .then(async() => {
                    await axios.post('/login', credentials)
                        .then((response) => {
                            console.log(response);
                            localStorage.authenticated = 1;
                            console.log(localStorage.authenticated);
                        }).catch((error) => {
                            // document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
                            console.log(error);
                            console.log(error.response);
                            console.log(error.response.data.message);
                            console.log(error.response.data.errors);
                            if(typeof error.response.data.errors != "undefined"){
                                validationErrors = error.response.data.errors;
                            } else {
                                window.$func.getAlert('error', 'Не верные данные', error.response?.data?.message??error.response?.statusText??'какая-то ошибка при входе');
                            }
                        });
                })
                .then(() => {
                    // console.log('error');
                    return attempt();
                });
            if(validationErrors) return validationErrors;
            return attempt();
        } catch (e) {
            console.log(e);
            // return Promise.reject(e.response.data.errors)
        }
    }

    const logout = async () => {
        // await axios.get('/sanctum/csrf-cookie')
        try {
            await axios.post('/logout')
                .then(response => {
                    localStorage.authenticated = 0;
                    store.commit('setUser', {});
                    return attempt();
                })
                .catch(error => {
                    window.$func.exceptionsHandler(error);
                });
        } catch (e) {
            console.log(e);
            // return Promise.reject(e.response.data.errors)
        }
    }

    const attempt = async () => {
        try {
            console.log('start attempt');
            let result = null;
            await axios.get('/sanctum/csrf-cookie')
            .then(async() => {
                await axios.post('/web-api/auth-user')
                .then(response => {
                    // console.log(response);
                    localStorage.authenticated = 1;
                    store.commit('setUser', response.data.data);
                    store.commit('setAccess', true);
                    store.state.sessionTime.time = store.state.sessionTime.max;
                    result = response;
                })
                .catch(error => {
                    // console.log(error);
                    localStorage.authenticated = 0;
                    store.commit('setUser', {});
                    store.commit('setAccess', false);
                })
                .then(() => {
                    console.log('result after get user');
                    return result;
                });
            })
            .catch(error => {
                console.log(error);
                localStorage.authenticated = 0;
                store.commit('setUser', {});
                store.commit('setAccess', false);
            });
        // console.log(result);
            return result;
        } catch (e) {
            console.log(e);
            localStorage.authenticated = 0;
            store.commit('setUser', {});
        }
    }

    return {
        login,
        logout,
        attempt
    }
}